var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useHeaderContext } from '@s7/header';
import { connect } from 'react-redux';
import { Self } from '../../../shared/self';
import { HeaderProfileAuthorized } from './HeaderProfileAuthorized';
import { HeaderProfileUnauthorized } from './HeaderProfileUnauthorized';
import { ProfileInfoWidget } from '../../profile-info';
import { HEADER_Z_INDEX } from './HeaderWidget';
var mapStateToProps = function (state) { return ({
    lang: state.App.lang,
}); };
var getPopoverProps = function (isDesktop) { return ({
    offset: { mainAxis: isDesktop ? 20 : 2, crossAxis: isDesktop ? 10 : -4 },
    position: 'bottom-end',
    withinPortal: false,
}); };
export var HeaderProfile = connect(mapStateToProps)(function (props) {
    var lang = props.lang, others = __rest(props, ["lang"]);
    var _a = Self.useSelf(), authorized = _a.authorized, pendingSelf = _a.pendingSelf, pendingUpdate = _a.pendingUpdate;
    var device = useHeaderContext().device;
    var isProfileLoading = pendingSelf || pendingUpdate;
    return authorized || isProfileLoading ? (React.createElement(ProfileInfoWidget, { lang: lang, popoverProps: getPopoverProps(device === 'DESKTOP'), drawerProps: { zIndex: HEADER_Z_INDEX } },
        React.createElement(HeaderProfileAuthorized, __assign({}, props, { loading: isProfileLoading })))) : (React.createElement(HeaderProfileUnauthorized, __assign({}, others)));
});
